export interface DashboardAccess {
  allowed: boolean;
  authenticated: boolean;
  ip: string;
}

export class DashboardAccessService {
  async getAccess(): Promise<DashboardAccess> {
    const response = await fetch('/api/dashboard/access', {
      credentials: 'same-origin',
    });
    const body = await this.readJson<Partial<DashboardAccess>>(response);

    if (response.status === 403) {
      return {
        allowed: false,
        authenticated: false,
        ip: body.ip ?? 'unknown',
      };
    }

    if (!response.ok || typeof body.allowed !== 'boolean') {
      throw new Error('Dashboard access check failed.');
    }

    return {
      allowed: body.allowed,
      authenticated: Boolean(body.authenticated),
      ip: body.ip ?? 'unknown',
    };
  }

  async authenticate(secretKey: string): Promise<DashboardAccess> {
    const response = await fetch('/api/dashboard/session', {
      body: JSON.stringify({ secretKey }),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
    });
    const body = await this.readJson<{ ip?: string }>(response);

    if (response.status === 403) {
      return {
        allowed: false,
        authenticated: false,
        ip: body.ip ?? 'unknown',
      };
    }

    if (response.status === 401) {
      throw new Error('Неверный secret key.');
    }

    if (!response.ok) {
      throw new Error('Не удалось выполнить вход.');
    }

    return {
      allowed: true,
      authenticated: true,
      ip: body.ip ?? 'unknown',
    };
  }

  private async readJson<T>(response: Response): Promise<T> {
    return (await response.json().catch(() => ({}))) as T;
  }
}
